interface UrlLinksProps {
  [key: string]: string;
}

const urlLinks: UrlLinksProps = {
  contactUs: 'https://info.jupiterone.com/contact-us',
};

const ROOT_URL =
  'https://raw.githubusercontent.com/JupiterOne/docs/main/assets/brand/';

const J1Images: UrlLinksProps = {
  lostSpacePerson: ROOT_URL + 'astronaut.png',
  billingObservatoryV2: ROOT_URL + 'J1_Observatory%20v1%20@2x.png',
  billingObservatory: ROOT_URL + 'observatory.png',
};

export default { ...urlLinks, ...J1Images };
